import { Host, h } from '@stencil/core';
export class AibaOptionSelectArray {
  constructor() {
    this.renderSelectOptionsArray = () => {
      if (this.selectOptionsArrayState) {
        const length = this.selectOptionsArrayState.length;
        return this.selectOptionsArrayState.map((opt, index) => {
          const disabled = this.disableTillSelection ? (index === 0 ? false : index < length - this.filledIndex) : opt === null || opt === void 0 ? void 0 : opt.disabled;
          return (h("div", { class: "option-select-wrapper" }, h("aiba-select-input", Object.assign({}, opt, { disabled: disabled, selectIndex: (opt === null || opt === void 0 ? void 0 : opt.selectIndex) ? opt === null || opt === void 0 ? void 0 : opt.selectIndex : index + 1, parentId: this._id }))));
        });
      }
    };
    this.styles = undefined;
    this.classes = undefined;
    this.handlers = undefined;
    this.selectOptionsArray = undefined;
    this.disableTillSelection = false;
    this.singleActiveSelection = true;
    this._id = undefined;
    this.optionValues = [];
    this.filledIndex = 0;
    this.activeSelect = undefined;
    this.selectOptionsArrayState = undefined;
  }
  async updateData(event) {
    if (event.detail.selectOptionsArray && this._id && event.detail.id === this._id) {
      this.selectOptionsArrayState = JSON.parse(JSON.stringify([...event.detail.selectOptionsArray]));
      this.optionValues = this.optionValues.map(item => {
        var _a;
        const optionItem = (_a = event.detail.selectOptionsArray) === null || _a === void 0 ? void 0 : _a.find(e => e.name === item.name);
        if (optionItem) {
          item.value = optionItem.value;
        }
        return item;
      });
    }
  }
  async selectValue(event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (((_a = event.detail) === null || _a === void 0 ? void 0 : _a.parentId) && this._id && event.detail.parentId !== this._id) {
      return;
    }
    let nameExists = false;
    this.optionValues.map(item => {
      var _a, _b;
      if (item.name === ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.name)) {
        item.value = (_b = event.detail) === null || _b === void 0 ? void 0 : _b.value;
        nameExists = true;
      }
    });
    if (!nameExists) {
      this.optionValues.push({
        name: (_b = event.detail) === null || _b === void 0 ? void 0 : _b.name,
        value: (_c = event.detail) === null || _c === void 0 ? void 0 : _c.value,
      });
    }
    this.activeSelect = (_d = event.detail) === null || _d === void 0 ? void 0 : _d.index;
    if (this.disableTillSelection &&
      (this.optionValues.length === 1 || this.optionValues.length === 2) &&
      ((_e = event.detail) === null || _e === void 0 ? void 0 : _e.name) === 'state' &&
      this.handlers &&
      this.handlers.handleWeatherStateSelected) {
      const countyList = await ((_f = this.handlers) === null || _f === void 0 ? void 0 : _f.handleWeatherStateSelected((_g = event.detail) === null || _g === void 0 ? void 0 : _g.value, { event: Object.assign({}, event), id: this._id }));
      this.selectOptionsArrayState[1].options = countyList;
      // reset county select when state is changed
      this.selectOptionsArrayState[1].value = '';
      this.selectOptionsArrayState[1].initialValue = '';
      this.optionValues = this.optionValues.map(e => {
        if (e.name === 'county') {
          e.value = '';
        }
        return e;
      });
    }
    if (this.disableTillSelection &&
      (this.optionValues.length === 1 || this.optionValues.length === 2) &&
      ((_h = event.detail) === null || _h === void 0 ? void 0 : _h.name) === 'county' &&
      this.handlers &&
      this.handlers.handleWeatherCountySelected) {
      (_j = this.handlers) === null || _j === void 0 ? void 0 : _j.handleWeatherCountySelected((_k = event.detail) === null || _k === void 0 ? void 0 : _k.value, { event: Object.assign({}, event), id: this._id });
    }
    this.filledIndex = this.optionValues.length;
  }
  componentWillLoad() {
    this.selectOptionsArrayState = this.selectOptionsArray;
  }
  componentDidUpdate() {
    if (this.optionValues.length === this.selectOptionsArrayState.length) {
      this.selectOptionsArrayValue.emit(this.optionValues);
    }
    //close a select container if another is open
    if (this.parentRef.querySelectorAll('.select-container') && this.singleActiveSelection) {
      let selectContainers = this.parentRef.querySelectorAll('.select-container');
      let selectContainersArray = Array.prototype.slice.call(selectContainers);
      selectContainersArray.map(item => {
        if (!item.classList.contains(`select-item-${this.activeSelect}`)) {
          item.classList.remove('active');
        }
      });
    }
  }
  render() {
    return (h(Host, { ref: el => (this.parentRef = el) }, this.styles && h("style", null, this.styles), h("div", { class: 'option-select-array-container', id: this._id }, h("div", { class: this.classes ? this.classes : 'option-select-array-item' }, this.renderSelectOptionsArray()))));
  }
  static get is() { return "aiba-option-select-array"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-option-select-array.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-option-select-array.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "selectOptionsArray": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "select-options-array",
        "reflect": false
      },
      "disableTillSelection": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-till-selection",
        "reflect": false,
        "defaultValue": "false"
      },
      "singleActiveSelection": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "single-active-selection",
        "reflect": false,
        "defaultValue": "true"
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "optionValues": {},
      "filledIndex": {},
      "activeSelect": {},
      "selectOptionsArrayState": {}
    };
  }
  static get events() {
    return [{
        "method": "selectOptionsArrayValue",
        "name": "selectOptionsArrayValue",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "option-select-array-data-update",
        "method": "updateData",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "selectValue",
        "method": "selectValue",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-option-select-array.js.map
